// Ekspor CSV (dibuka di Excel) & cetak — port csv()/printHtml() v1 (core.js).

type Col<T> = [header: string, value: keyof T | ((r: T) => unknown)];

/** CSV pemisah ";" (locale Indonesia), desimal koma, teks diawali = + - @ dinetralkan (cegah formula injection). */
export function csv<T extends Record<string, unknown>>(filename: string, cols: Col<T>[], rows: T[]): void {
  const cell = (v: unknown) => {
    let s = typeof v === 'number' && !Number.isInteger(v) ? String(v).replace('.', ',') : String(v ?? '');
    if (typeof v !== 'number' && /^[=+\-@\t\r]/.test(s)) s = `'${s}`;
    return /[";\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const lines = [
    cols.map((c) => cell(c[0])).join(';'),
    ...rows.map((r) => cols.map((c) => cell(typeof c[1] === 'function' ? c[1](r) : r[c[1]])).join(';')),
  ];
  const blob = new Blob([`﻿${lines.join('\r\n')}`], { type: 'text/csv;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
}

/** Cetak HTML lewat #printRoot (CSS @media print v1 menampilkan hanya .print-only). */
export function printHtml(html: string): void {
  const root = document.getElementById('printRoot');
  if (!root) return;
  root.innerHTML = html;
  setTimeout(() => window.print(), 50);
}
